<template>
  <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
    <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-data-table :headers="headers" :items-per-page="4" :items="dashboardUsers" :loading="isLoading"
        hide-default-footer disable-sort>
        <template v-slot:loading>
          <div class="d-flex align-center justify-center pa-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <span class="ml-2">Loading data...</span>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="d-flex align-center justify-center pa-4">
            <v-icon color="secondary">mdi-information</v-icon>
            <span class="ml-2">No data found</span>
          </div>
        </template>
        <template v-slot:no-results>
          <div class="d-flex align-center justify-center pa-4">
            <v-icon color="secondary">mdi-magnify</v-icon>
            <span class="ml-2">No matching data found</span>
          </div>
        </template>

        <template v-slot:item.user_ib_status="{ item }">
          <div class="client-status-selection status-selection">
            <v-select :disabled="$canRoute('registered-user?tab=1') !== 1" solo :items="ibStatusSlots"
              append-icon="mdi-chevron-down" class="custom-select client-width" v-model="item.user_ib_status"
              item-text="user_ib_status" item-value="user_ib_status" :class="getTextColor(item.user_ib_status)"
              @change="handleSelectChange(item)">
              <template v-slot:item.user_ib_status="{ item }">
                {{ item.user_ib_status }}
              </template>
            </v-select>
          </div>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ formatMySQLDate(item?.created_at) }}
        </template>
        <template v-slot:item.email="{ item }">
          <v-tooltip top color="#000">
            <template v-slot:activator="{ on }">
              <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                {{ obfuscateAnyEmail(item?.email) }}
                <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">{{
                  copiedStates[item.id] ? "mdi mdi-check" : "mdi-content-copy"
                }}</v-icon>
              </v-btn>
            </template>
            <span>{{ item.email }}</span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.manager="{ item }">
          <v-dialog transition="scale-transition" origin="center center" max-width="985px" v-model="searchManagerModal"
            content-class="upload-modal">
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex align-items-center">
                <div v-bind="attrs" v-on="on" :class="verifyModal(item.managerModal)">
                  <v-btn x-small icon tile style="background: #039de91a">
                    <v-icon x-small color="#039de9">mdi-plus</v-icon>
                  </v-btn>
                </div>
              </div>
            </template>

            <template>
              <v-card-title class="upload-title">
                <span>Click Assign Button to Assign Manager</span>
                <v-btn icon dark @click="searchManagerModal = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <AssignManagerTable></AssignManagerTable>
            </template>
          </v-dialog>
        </template> -->
        <template v-slot:item.fullname="{ item }">
          <router-link v-if="$canRoute('registered-user?tab=1') === 1" class="text-capitalize text--ash" :to="`/registered-user-details/${item.id}`">
            {{ item.fullname }}
          </router-link>
          <span v-else class="text-capitalize text--ash">{{ item.fullname }}</span>
        </template>
        <template v-slot:item.details="{ item }">
          <router-link class="links text-decoration-none"
            :to="`/registered-user-details/${item?.id}`">
            <v-icon color="#039de9" small> mdi-eye-outline </v-icon>
          </router-link>
        </template>
        <template v-slot:item.admin_name="{ item }">
          {{ item?.admin_name || "N/A" }}
        </template>
        <!-- <template v-slot:item.user_doc_status="{ item }">
          <div :style="{
            display: 'flex',
            gap: '2px',
            alignItems: 'center',
            justifyContent: item.user_doc_status.startsWith('V')
              ? 'normal'
              : 'space-between',
          }">
            <v-icon small>
              {{ verifyDocIcon(item.user_doc_status) }}
            </v-icon>
            {{ item.user_doc_status }}
            <div v-if="item.user_doc_status !== 'Verified'" v-bind="attrs" v-on="on">
              <v-btn :to="{ path: '/profile-verify', query: { id: item.id } }" x-small icon tile
                style="background: #039de91a">
                <v-icon x-small color="#039de9">mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </template> -->
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { REGISTEREDUSER__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import AssignManagerTable from "./AssignManagerTable.vue";
import ProfileVerifyModal from "./ProfileVerifyModal.vue";

export default {
  data() {
    return {
      isCopied: false,
      copiedStates: {},
      uploadModal: false,
      searchManagerModal: false,
      ibStatusSlots: ["Client", "Approved", "Requested", "Cancelled"],
      dialog: false,
      modal: false,
      selectedSlot: "",
      slots: [
        { text: "Approved", value: "Approved", class: "text-approved" },
        { text: "Inactive ", value: "Declined", class: "text-decline" },
        { text: "Pending", value: "Pending", class: "text-pending" },
      ],
      headers: [
        { text: "User ID", align: "start", value: "id" },
        { text: "Name", value: "fullname" },
        { text: "Email", value: "email" },
        { text: "Registered By", align: "start", value: "admin_name" },
        // { text: "Document", value: "user_doc_status" },
        { text: "IB Status", value: "user_ib_status" },
        { text: "Registered At", align: "start", value: "created_at" },
        // { text: "Manager", value: "manager" },
      ],
    };
  },
  components: {
    ProfileVerifyModal,
    AssignManagerTable,
  },
  computed: {
    ...mapState("registeredUser", ["dashboardUsers", "isLoading"]),
  },
  methods: {
    formatMySQLDate,
    ...mapActions("registeredUser", [
      REGISTEREDUSER__ACTIONS.DASHBOARDREGISTEREDUSERS,
      REGISTEREDUSER__ACTIONS.UPDATEIBSTATUS,
    ]),

    handleSelectChange(item) {
      const parameter = { userId: item.id, ib_status: item.user_ib_status };
      this[REGISTEREDUSER__ACTIONS.UPDATEIBSTATUS](parameter);
    },

    getTextColor(item) {
      const firstLetter = item.charAt(0).toLowerCase();

      const colorMap = {
        a: "#ff0000",
        b: "#00ff00",
      };

      if (colorMap[firstLetter]) {
        return colorMap[firstLetter];
      } else {
        const colors = [
          "#ff0000",
          "#00ff00",
          "#0000ff",
          "#ffff00",
          "#00ffff",
          "#ff00ff",
          "#000000",
          "#ffffff",
        ];
        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
      }
    },

    verifyDocIcon(status) {
      if (status.toLowerCase() === "verified")
        return "mdi mdi-check-circle-outline green--text mr-1";
      else if (status.toLowerCase() === "not verified")
        return "mdi mdi-close-circle-outline red--text mr-1";
      else if (status.toLowerCase() === "pending")
        return "mdi mdi-refresh yellow--text mr-1";
      else if (
        status.toLowerCase() === "pending" ||
        status.toLowerCase() === "not verified"
      )
        return "mdi mdi-clock-alert yellow--text mr-1";
      else return "mdi mdi-refresh yellow--text mr-1";
    },

    verifyModal(statusModal) {
      if (statusModal === "Verified") return "d-none ml-0";
      else if (statusModal === "Decline") return "d-block ml-2";
      else return "d-block ml-2";
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },
  },
  async mounted() {
    this[REGISTEREDUSER__ACTIONS.DASHBOARDREGISTEREDUSERS]();
    if (this.$canRoute('registered-user?tab=1') === 1) {
      this.headers.push({ text: "Details", value: "details" });
    }
  },
};
</script>

<style>
.client-status-selection{
  display: flex;
  justify-content: center;
  background-color: transparent;
}
.client-width{
  max-width: 155px;
}
</style>
